// @ts-nocheck
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigationType } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import useIsMount from 'helpers/useIsMount'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import blogListFragment from 'js/blog/fragments/listFragment'
import FetchMore from 'js/components/FetchMore'
import FilterWrapper from 'js/components/FilterWrapper'
import { Container } from 'js/components/Grid'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import Select from 'js/components/Select/Select'
import discussionListFragment from 'js/discussions/fragments/listFragment'
import eventListFragment from 'js/events/fragments/EventListFragment.fragment'
import { genericArticleListFragment } from 'js/genericArticle/fragments/genericArticleEntity'
import statusUpdateListFragment from 'js/group/StatusUpdate/fragments/listFragment.js'
import newsListFragment from 'js/news/fragments/listFragment'
import { podcastListFragment } from 'js/podcast/fragments/list'
import questionListFragment from 'js/questions/fragments/listFragment'
import wikiListFragment from 'js/wiki/fragments/listFragment'

import Card from './components/Card'

const List = () => {
    const { t } = useTranslation()
    const [subtype, setSubtype] = useState('all')

    const PAGE_SIZE = 5
    const { loading, data, fetchMore, refetch } = useQuery<any>(
        GET_BOOKMARKS_LIST,
        {
            variables: {
                offset: 0,
                limit: PAGE_SIZE,
                subtype,
            },
        },
    )

    useWindowScrollPosition('saved')

    const isMount = useIsMount()
    const navigationType = useNavigationType()

    useEffect(() => {
        if (isMount && navigationType !== 'POP') {
            refetch()
        }
    })

    return (
        <>
            <PageHeader title={t('action.bookmarked')} />

            <Section>
                <Container size="tiny">
                    <FilterWrapper style={{ marginBottom: '16px' }}>
                        <Select
                            name="subtype"
                            label={t('global.type')}
                            options={[
                                {
                                    value: 'all',
                                    label: t('global.all'),
                                },
                                {
                                    value: 'blog',
                                    label: t('entity-blog.name', { count: 2 }),
                                },
                                {
                                    value: 'news',
                                    label: t('entity-news.name', { count: 2 }),
                                },
                                {
                                    value: 'discussion',
                                    label: t('entity-discussion.name', {
                                        count: 2,
                                    }),
                                },
                                {
                                    value: 'question',
                                    label: t('entity-question.name', {
                                        count: 2,
                                    }),
                                },
                                {
                                    value: 'event',
                                    label: t('entity-event.name', { count: 2 }),
                                },
                                {
                                    value: 'podcast',
                                    label: t('entity-podcast.name', {
                                        count: 2,
                                    }),
                                },
                                {
                                    value: 'statusupdate',
                                    label: t('entity-statusupdate.name', {
                                        count: 2,
                                    }),
                                },
                                {
                                    value: 'wiki',
                                    label: t('entity-wiki.name', { count: 2 }),
                                },
                            ]}
                            onChange={setSubtype}
                            value={subtype}
                        />
                    </FilterWrapper>

                    {loading ? (
                        <LoadingSpinner />
                    ) : (
                        data?.bookmarks && (
                            <FetchMore
                                edges={data.bookmarks.edges}
                                getMoreResults={(data) => data.bookmarks.edges}
                                fetchMore={fetchMore}
                                fetchType="click"
                                fetchCount={10}
                                maxLimit={data.bookmarks.total}
                            >
                                {data.bookmarks.edges.map((entity, i) => (
                                    <Card
                                        key={entity.guid}
                                        data-feed={i}
                                        entity={entity}
                                        viewer={data.viewer}
                                    />
                                ))}
                            </FetchMore>
                        )
                    )}
                </Container>
            </Section>
        </>
    )
}

const GET_BOOKMARKS_LIST = gql`
    query BookmarkList($offset: Int!, $limit: Int!, $subtype: String, $groupGuid: String) {
        viewer {
            guid
            loggedIn
            user {
                guid
                email
            }
        }
        bookmarks(offset: $offset, limit: $limit, subtype: $subtype) {
            total
            edges {
                guid
                ...StatusUpdateListFragment
                ...BlogListFragment
                ...DiscussionListFragment
                ...EventListFragment
                ...NewsListFragment
                ...QuestionListFragment
                ...WikiListFragment
                ${podcastListFragment}
                ${genericArticleListFragment}
            }
        }
    }
    ${statusUpdateListFragment}
    ${blogListFragment}
    ${discussionListFragment}
    ${eventListFragment}
    ${newsListFragment}
    ${questionListFragment}
    ${wikiListFragment}
`

export default List
